/**
 * 검색 세션 = 히스토리 한 칸.
 *
 * 검색 페이지 안에서 일어나는 이동(새 검색·이 지역에서 검색·내 주변·필터·
 * 이용 방식·카테고리)은 모두 같은 "검색" 한 칸을 덮어쓴다(replace). 그래야
 * 뒤로가기가 검색을 한 번에 빠져나간다. 검색 페이지 밖에서 들어올 때만 push.
 */

/** `/{locale}/s` 또는 `/{locale}/s/…` 이면 검색 페이지. */
const SEARCH_PATHNAME = /^\/[^/]+\/s(?:\/|$)/;

/** `/{locale}/s` 또는 `/{locale}/s/…` 이면 검색 페이지. */
export function isSearchPathname(pathname: string): boolean {
  return SEARCH_PATHNAME.test(pathname);
}

/** 검색 페이지 URL 로 이동. 이미 검색 페이지면 replace, 아니면 push. */
export function navigateToSearch(
  router: { push(href: string): void; replace(href: string): void },
  currentPathname: string,
  href: string,
): void {
  if (isSearchPathname(currentPathname)) {
    router.replace(href);
    return;
  }
  router.push(href);
}
